import axios from 'axios';

const state = {
	documentations: [],
	documentation: {},
	index: '',
	sortBy: '',
	sortDesc: '',
	paths: [],
	integrationsOptions: [],
};

const getters = {
	getDocumentations: state => state.documentations,
	getDocumentation: state => state.documentation,
	getIndex: state => state.index,
	getSortBy: state => state.sortBy,
	getSortDesc: state => state.sortDesc,
	getPaths: state => state.paths,
	getIntegrationsOptions: state => state.integrationsOptions,
};

const actions = {
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		const url = 'documentations';

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters['documentations/getSortBy'],
						sortDesc: context.rootGetters['documentations/getSortDesc'],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				context.commit('setDocumentations', res.data.data);
				return res.data.pagination;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},

	fetchPaths: async context => {
		const url = 'documentations/paths';
		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => {
				context.commit('setPaths', res.data.data);
				return res.data.data;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},

	fetchIntegrationsOptions: async context => {
		const url = 'integrations/options';
		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => {
				context.commit('setIntegrationsOptions', res.data.data);
				return res.data.data;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},

	getDetailDocumentation: async (context, payload) => {
		const url = `documentations/detail/${payload}`;
		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => ({ data: res.data }))
			.catch(err => {
				console.log('errore', err);
			});
	},

	deleteDocumentations: async (context, payload) => {
		const url = 'documentations/delete';
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{ data: { query: payload } },
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => res.data)
			.catch(err => {
				console.log('errore', err.response && err.response.status);
				return { error: err.response && err.response.status };
			});
	},

	destroyData: context => {
		context.commit('setDocumentations', []);
		context.commit('setDocumentation', {});
	},
};

const mutations = {
	setDocumentations: (state, value) => {
		state.documentations = value;
	},
	setDocumentation: (state, value) => {
		state.documentation = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
	setPaths: (state, value) => {
		state.paths = value;
	},
	setIntegrationsOptions: (state, value) => {
		state.integrationsOptions = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
